import React from "react";
import { Box, Typography, Stack } from "@mui/material";

const ChartLegend = ({ data, onTriggerLegend }) => {
  return (
    <Stack
      direction="row"
      spacing="20px"
      alignItems="center"
      sx={{ marginLeft: "43px", marginTop: "10px", cursor: "pointer" }}
    >
      {data.map((legend) => (
        <Stack
          key={legend.key}
          direction="row"
          spacing="5px"
          alignItems="center"
          sx={{ fontSize: "15px" }}
          onClick={() => onTriggerLegend && onTriggerLegend(legend.key)}
        >
          <i
            className={`fa ${legend.show ? "fa-check-circle" : "fa-circle-o"}`}
            style={{ color: legend.show ? legend.backgroundColor : "#6B7280" }}
            aria-hidden="true"
          ></i>
          <Typography
            sx={{
              fontSize: "12px",
              color: legend.show ? "#4A4D52" : "#6B7280",
            }}
          >
            {legend.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default ChartLegend;
